export const components = {
  Card: { paddingLG: 18 },
  Button: { borderRadiusSM: 6 },
  Alert: { fontSize: 13, lineWidth: 2 },
  App: { lineHeight: 2 },
}
